<template>
  <div>
    <div>
      <div class="sixteentosix sixteentosix-wrap omt-6 omt-md-25">
        <div class="new-background-wrap">
          <div
            class="kachelimage header-image zoom-image"
            style="
              background: url('/static/img/laptop_lock_1.jpg');
              background-position: top !important;
            "
          ></div>
          <!-- <img src="/static/img/laptop_lock_1.jpg" /> -->
          <div class="headline-wrap">
            <div class="headline">
              <div class="text-subtitle-2 text-md-h5">
                {{ $t("manage_newsletter") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Breadcrumb />
    <div class="mx-0 row align-items-start newsletter_management">
      <div class="col-xl-12 px-8">
        <div
          class="pt-4 mx-0 row main_tabuler justify-content-sm-between justify-content-center"
        >
          <div class="tab_sub">
            <v-tabs v-model="selectedTab" align-with-title touchless>
              <v-tab class="newletter_tab1 pl-0">
                <div class="t_pack">
                  <v-icon class="duplicate-icon" small>fa-light fa-user</v-icon>
                  {{ $t("Subscribers") }}
                </div>
              </v-tab>
              <v-tab class="newletter_tab1">
                <div class="t_pack">
                  <v-icon class="duplicate-icon" small
                    >fa-light fa-envelope</v-icon
                  >
                  {{ $t("newsletter") }}
                </div>
              </v-tab>
            </v-tabs>
          </div>
        </div>
        <div class="d-flex justify-end create_nl mb-5">
          <a
            v-if="selectedTab === 1"
            @click="goToCreateNewsletter"
            class="crnl_a"
          >
            <img src="/static/img/edit_pen.svg" alt="Edit" class="ed_icon" />
            {{ $t("compose_newsletter") }}</a
          >
        </div>

        <v-tabs-items v-model="selectedTab" class="pt-1" touchless>
          <v-tab-item>
            <div v-if="showSubscriber">
              <div class="sub_group_head">
                <div class="sub_group_head_left">
                  <v-select
                    :items="itemsAudience"
                    item-text="name"
                    item-value="id"
                    dense
                    outlined
                    class="datainput"
                    v-model="selectedAudience"
                    @change="getAllSubcriberForSelectedAudience"
                  >
                    <template v-slot:prepend-inner>
                      <i class="fas fa-users"></i>
                    </template>
                  </v-select>

                  <v-btn
                    @click="showAudienaceTab"
                    class="sales-list-buttons-1"
                    >{{ $t("subscriber_group") }}</v-btn
                  >
                </div>

                <div class="sub_group_head_right">
                  <template>
                    <v-menu
                      v-model="menu"
                      :close-on-content-click="false"
                      content-class="assign_popup"
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" text>
                          {{ $t("assign_to") }}
                          <img src="/static/img/more.png" alt="more" />
                        </v-btn>
                      </template>

                      <v-card style="min-width: 200px">
                        <v-list dense>
                          <v-list-item v-for="group in audiences" :key="group">
                            <v-checkbox
                              v-model="selectedGroups"
                              :label="
                                group.designation +
                                ' (' +
                                group.subscriptionCount +
                                ')'
                              "
                              :value="group.id"
                              hide-details
                              dense
                            />
                          </v-list-item>
                        </v-list>

                        <v-divider class="my-2"></v-divider>

                        <v-btn text color="primary" @click="assignGroups">
                          {{ $t("assign_audience_group") }}
                        </v-btn>
                        <!-- <v-divider class="my-2"></v-divider> -->
                        <v-btn class="close_btn_link" @click="removeGroups">
                          {{ $t("remove_audience_group") }}
                        </v-btn>
                      </v-card>
                    </v-menu>
                  </template>
                </div>
              </div>
              <v-simple-table
                class="userstable subscriber_table"
                style="width: 100%"
                hide-default-footer
              >
                <thead>
                  <tr>
                    <th
                      class="text-uppercase align-center table-trainer-wrapper-head"
                      id="#"
                    >
                      #
                    </th>
                    <th
                      class="text-uppercase align-center table-trainer-wrapper-head"
                      id="email"
                    >
                      {{ $t("email_address") }}
                    </th>
                    <th
                      class="text-uppercase align-center table-trainer-wrapper-head"
                      id="firstname"
                    >
                      {{ $t("firstname") }}
                    </th>
                    <th
                      class="text-uppercase align-center table-trainer-wrapper-head"
                      id="lastname"
                    >
                      {{ $t("lastname") }}
                    </th>
                    <th
                      class="text-uppercase align-center table-trainer-wrapper-head"
                      id="lastname"
                    >
                      {{ $t("organization") }}
                    </th>

                    <th
                      class="text-uppercase align-center table-trainer-wrapper-head last_h_row"
                      id="preferredLanguage"
                    >
                      {{ $t("preferredLanguage") }}
                    </th>

                    <th
                      class="text-uppercase align-center table-trainer-wrapper-head"
                      id="subcription_status"
                    >
                      {{ $t("subcription_status") }}
                    </th>
                    <th
                      class="text-uppercase align-center table-trainer-wrapper-head"
                      id="date"
                    >
                      {{ $t("date") }}
                    </th>

                    <th
                      class="text-uppercase align-center table-trainer-wrapper-head"
                      stye="text-align:right !important;"
                      id="action"
                    >
                     
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(user, i) in subscribers"
                    :key="user.id"
                    :class="{
                      active_row: selectedSubscriber.includes(user.id),
                    }"
                  >
                    <td class="text-uppercase align-center">
                      <v-checkbox
                        v-model="selectedSubscriber"
                        :value="user.id"
                        hide-details
                        dense
                        @change="getAllSelectedAudienceIds()"
                        :disabled="user.subcriptionStutus == 0"
                      />
                    </td>
                    <td class="text-uppercase align-center nc_2">
                      <div class="org_wrap">
                        <div
                          v-if="user.audiences.length == 0"
                          class="dot"
                        ></div>
                        {{ user.subscriptionMail }}
                      </div>
                      <div class="degi_wrap">
                        {{ getAudienceGroup(user.audiences) }}
                      </div>
                    </td>
                    <td class="text-uppercase align-center nc_2">
                      {{ user.firstName }}
                    </td>
                    <td class="text-uppercase align-center nc_2">
                      {{ user.lastName }}
                    </td>
                    <td class="text-uppercase align-center nc_2">
                      {{ user.organisation }}
                    </td>
                    <td class="text-uppercase align-center">
                      <div class="flg_manag">
                        <img
                          :src="
                            '/files/flags/' + getFlag(user.preferredLanguage)
                          "
                          alt="flag"
                          class="flag-icon"
                        />
                        {{ getLanguageName(user.preferredLanguage) }}
                      </div>
                    </td>

                    <td class="text-uppercase align-center nc_3">
                      <div class="nc_3_inner">
                        <i
                          v-if="user.subcriptionStutus == 1"
                          class="fas fa-check text-success"
                        ></i>
                        <i
                          v-else-if="user.subcriptionStutus == 0"
                          class="fas fa-hourglass-start text-warning"
                        ></i>
                        <i
                          v-else-if="user.subcriptionStutus == 2"
                          class="fas fa-times-circle text-danger"
                        ></i>
                        {{
                          user.subcriptionStutus == 1
                            ? $t("subscribed")
                            : user.subcriptionStutus == 0
                            ? $t("yet_to_subscribe")
                            : user.subcriptionStutus == 2
                            ? $t("un_subscribed")
                            : ""
                        }}
                      </div>
                    </td>
                    <td class="text-uppercase align-center">
                      {{ user.formattedSubscriptionDate }}
                    </td>
                    <td
                      class="text-uppercase align-center"
                      style="text-align: right !important"
                    >
                      <span
                        @click="openDeleteSubscriberDialog(user.id)"
                        v-if="user.subcriptionStutus == 2"
                      >
                        <img src="/static/img/close_delete.svg" alt="Delete" />
                      </span>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
              <div class="span_wrap">
                <span class="sppn"
                  >{{ totalRecords > 0 ? page : 0 }} &nbsp;{{
                    this.$t("of")
                  }}&nbsp;{{ totalPages }} ({{ totalRecords }}
                  {{ this.$t("records") }})
                </span>
                <span class="no_ra" v-if="totalRecords == 0">{{
                  $t("no_records")
                }}</span>
              </div>
              <pagination
                class="my-2"
                :current-page="page"
                :total-pages="totalPages"
                :show-previous-page="previousPage"
                :show-next-page="nextPage"
                :show-current-page="showCurrentPage"
              ></pagination>
            </div>
            <div v-if="showAudienace">
              <div class="create_group_head">
                <div class="create_group_head_left">
                  <p>{{ $t("subscriber_group") }}</p>
                </div>
                <div class="create_group_head_right">
                  <v-btn @click="showSubscriberTab" class="">
                    <img
                      src="/static/img/back_arrow.png"
                      class="back_arrow"
                      alt="back_arrow"
                    />
                    {{ $t("back") }}</v-btn
                  >
                  <v-btn @click="openDialog(null)" class="btn_ep_arrow">
                    <img
                      src="/static/img/event-plus.svg"
                      class="ep_arrow"
                      alt="plus"
                    />
                    {{ $t("create_group") }}</v-btn
                  >
                </div>
              </div>

              <v-simple-table
                class="sub_group_table"
                style="width: 100%"
                hide-default-footer
              >
                <thead>
                  <tr>
                    <th class="align-center table-trainer-wrapper-head" id="#">
                      {{ $t("#") }}
                    </th>
                    <th
                      class="align-center table-trainer-wrapper-head"
                      id="name"
                    >
                      {{ $t("name_of_group") }}
                    </th>
                    <th
                      class="align-center table-trainer-wrapper-head"
                      id="blank"
                    ></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="designation-border"
                    v-for="(audience, i) in audiences"
                    :key="audience.id"
                  >
                    <td
                      class="pb-1 align-center"
                      @click="getSubscribersWithAudienceFilter(audience.id)"
                    >
                      {{ i + 1 }}
                    </td>
                    <td
                      class="pb-1 align-center"
                      @click="getSubscribersWithAudienceFilter(audience.id)"
                    >
                      {{ audience.designation }}
                      <span>
                        ({{
                          audience.subscriptionCount != null
                            ? audience.subscriptionCount
                            : 0
                        }})</span
                      >
                    </td>

                    <td class="pb-1 align-center">
                      <div class="ed_icon">
                        <span @click="openDialog(audience)">
                          <img src="/static/img/edit_pen.svg" alt="Edit" />
                        </span>
                        <span @click="openDeleteAudienceDialog(audience.id)">
                          <img
                            src="/static/img/close_delete.svg"
                            alt="Delete"
                          />
                        </span>
                      </div>
                    </td>
                  </tr>
                  <tr v-show="audiences.length == 0">
                    <td class="pb-1 text-uppercase align-center" colspan="6">
                      {{ $t("no_records") }}
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </div>
          </v-tab-item>
          <v-tab-item>
            <v-simple-table
              class="userstable sub_table"
              style="width: 100%"
              hide-default-footer
            >
              <thead>
                <tr>
                  <th
                    class="text-uppercase align-center table-trainer-wrapper-head"
                    id="th-new"
                  >
                    #
                  </th>
                  <th
                    @click="setSort('title')"
                    class="text-uppercase align-center table-trainer-wrapper-head"
                    id="id-newsletter"
                  >
                    {{ $t("subject") }}
                    <v-icon v-show="sort === 'title' && order"
                      >fas fa-chevron-down</v-icon
                    >
                    <v-icon v-show="sort === 'title' && !order"
                      >fas fa-chevron-up</v-icon
                    >
                  </th>

                  <th
                    @click="setSort('date')"
                    class="text-uppercase align-center table-trainer-wrapper-head ns_date_cell"
                    id="language-date"
                  >
                    {{ $t("date") }}
                    <v-icon v-show="sort === 'date' && order"
                      >fas fa-chevron-down</v-icon
                    >
                    <v-icon v-show="sort === 'date' && !order"
                      >fas fa-chevron-up</v-icon
                    >
                  </th>
                  <th></th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(newsletter, i) in newsletters" :key="newsletter.id">
                  <td class="text-uppercase align-center">
                    {{
                      currentPageNewsLetter * numberOfElementsNewsLetter + i + 1
                    }}
                  </td>
                  <td class="text-uppercase align-center ns_subject_cell">
                    <span v-if="newsletter?.isDuplicated === '1'"
                      >{{ $t("copy_of") }} </span
                    >{{
                      newsletter.subjectMap[$locale]
                        ? newsletter.subjectMap[$locale]
                        : $t("no_subject_line")
                    }}

                    <span class="" v-if="newsletter.newsletterstatus === '0'">
                    </span>
                    <span v-else>
                      <p class="total_sub">
                        <span>{{ newsletter.subscriberCount }}</span>
                        <span>{{ $t("Subscribers") }}</span>
                        <span>
                          ({{
                            getAudienceGroupNameSubscriber(
                              newsletter.audienceId
                            )
                          }})
                        </span>
                      </p>
                    </span>
                  </td>

                  <td class="text-uppercase align-center">
                    {{
                      formatDate(
                        newsletter.editedAt !== null
                          ? newsletter.editedAt
                          : newsletter.createdAt
                      )
                    }}
                  </td>
                  <td class="text-uppercase align-center">
                    <span
                      class="event-type-text"
                      v-if="newsletter.newsletterstatus === '0'"
                    >
                      {{ $t("draftedTrainingEvents1") }}
                    </span>
                    <span v-else>
                      <span class="event-type-text-green">{{
                        $t("published")
                      }}</span>
                    </span>
                  </td>
                  <td class="text-uppercase align-center">
                    <img
                      v-if="newsletter.newsletterstatus === '0'"
                      src="/static/img/edit_pen.svg"
                      @click="tableRowClicked(newsletter.id)"
                      style="cursor: pointer; width: 18px"
                      alt="Edit"
                    />

                    <img
                      v-else
                      src="/static/img/eye_nl_img.svg"
                      @click="showPreviewPopUp(newsletter.id)"
                      style="cursor: pointer; width: 22px"
                      alt="Preview"
                    />
                  </td>
                  <td class="text-uppercase align-center">
                    <img
                      v-if="newsletter.newsletterstatus === '0'"
                      src="/static/img/close_delete.svg"
                      @click="tableRowClickedDelete(newsletter.id)"
                      style="cursor: pointer; width: 22px; height: 22px"
                      alt="Delete"
                    />

                    <img
                      v-else
                      src="/static/img/copy_nl_img.svg"
                      @click="createDuplicate(newsletter.id)"
                      style="cursor: pointer; width: 23px"
                      alt="Duplicate"
                    />
                  </td>
                </tr>
              </tbody>

              <v-dialog
                v-model="openPreviewDialog"
                content-class="publish_popup"
                max-width="600px"
                attach="body"
              >
                <v-btn icon @click="openPreviewDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-card class="popup-container" style="overflow: visible">
                  <!-- <v-card-title class="popup-header">
                    
                    <span>{{ newsLetter?.subjectMap[$locale] }}</span>
                  </v-card-title> -->
                  <v-card-text class="popup-content">
                    <div v-if="newsLetter?.image" class="popup-image">
                      <img
                        :src="`/files/images/${newsLetter.image}`"
                        alt="Newsletter Image"
                      />
                    </div>
                    <div
                      class="popup-body"
                      v-html="newsLetter?.bodyMap[$locale]"
                    ></div>

                    <div
                      v-if="$locale === 'en'"
                      class="popup-body"
                      style="margin-top: 30px; line-height: 1.5"
                    >
                      <div>
                        <p style="margin: 0px; line-height: 1.5">
                          <b style="color: #000000">Imprint</b><br />

                          <span
                            >Knorr-Bremse Systeme für Schienenfahrzeuge
                            GmbH</span
                          ><br />
                          <span>Georg-Knorr Straße 4</span><br />
                          <span>12681 Berlin</span><br />
                          <span>Germany</span><br />
                          <br />
                          <span>Telephone: +49 89 3547-0</span><br />
                          <span>Fax: +49 89 3547-2767</span><br />
                          <span
                            >Email:
                            <a
                              class="font-grey"
                              href="mailto:info@knorr-bremse.com"
                              >info@knorr-bremse.com</a
                            ></span
                          ><br />
                          <br />
                          <span
                            >CEO: Mario Beinert, Dr.Peter Radina, Harald
                            Schneider, Cora Hentrich-Henne</span
                          ><br />
                          <br />
                          <span
                            >Chairman of the Supervisory Board: Dr.Nicolas
                            Lange</span
                          ><br />
                          <span>Munich Local Court</span><br />
                          <span>Register Court Munich: HRB 91181</span><br />
                          <span>Registered office of the company: Munich </span
                          ><br />
                          <span>VAT ID No.: DE129395680</span><br />

                          <a
                            href="https://training-railservices.knorr-bremse.com/files/images/KB_DS-Hinweise_Customer_Training_Portal_en.pdf"
                            >Privacy Policy</a
                          >
                        </p>
                        <p style="padding-top: 30px">
                          Don't want to stay up to date with Knorr-Bremse
                          RailServices Training Academy?<br />
                          You can always
                          <a href="#" style="text-decoration: none"
                            >Unsubscribe here</a
                          >
                        </p>
                      </div>
                    </div>

                    <div
                      v-if="$locale === 'de'"
                      class="popup-body"
                      style="margin-top: 30px; line-height: 1.5"
                    >
                      <div
                        class="content-1"
                        style="
                          padding-top: 30px;
                          margin-top: 30px;
                          border-top: 1px solid #d9d9d9;
                        "
                      >
                        <p style="margin: 0px; line-height: 1.5">
                          <b style="color: #000000">Impressum</b><br />

                          <span
                            >Knorr-Bremse Systeme für Schienenfahrzeuge
                            GmbH</span
                          ><br />
                          <span>Georg-Knorr Straße 4</span><br />
                          <span>12681 Berlin</span><br />
                          <span>Deutschland</span><br />
                          <br />
                          <span>Telephone: +49 89 3547-0</span><br />
                          <span>Fax: +49 89 3547-2767</span><br />
                          <span
                            >Email:
                            <a
                              class="font-grey"
                              href="mailto:info@knorr-bremse.com"
                              >info@knorr-bremse.com</a
                            ></span
                          ><br />
                          <br />
                          <span
                            >Geschäftsführer: Mario Beinert, Dr.Peter Radina,
                            Harald Schneider, Cora Hentrich-Henne</span
                          ><br />
                          <br />
                          <span
                            >Vorsitzender des Aufsichtsrates: Dr.Nicolas
                            Lange</span
                          ><br />
                          <span>Amtsgericht München</span><br />
                          <span>Registergericht München: HRB 91181</span><br />
                          <span>Sitz der Gesellschaft: München </span><br />
                          <span>USt.-IdNr.: DE129395680</span><br />

                          <a
                            href="https://training-railservices.knorr-bremse.com/files/images/KB_DS-Hinweise_Customer_Training_Portal_de.pdf"
                            >Datenschutzerklärung</a
                          >
                        </p>
                        <p style="padding-top: 30px">
                          Sie wollen nicht auf dem Laufenden bleiben mit der
                          Knorr-Bremse RailServices Training Academy?<br />
                          Sie können jederzeit
                          <a href="#" style="text-decoration: none"
                            >Hier abbestellen</a
                          >
                        </p>
                      </div>
                    </div>

                    <div
                      v-if="$locale === 'pl'"
                      class="popup-body"
                      style="margin-top: 30px; line-height: 1.5"
                    >
                      <div
                        class="content-1"
                        style="
                          padding-top: 30px;
                          margin-top: 30px;
                          border-top: 1px solid #d9d9d9;
                        "
                      >
                        <p style="margin: 0px; line-height: 1.5">
                          <b style="color: #000000">Impressum</b><br />

                          <span
                            >Knorr-Bremse Systeme für Schienenfahrzeuge
                            GmbH</span
                          ><br />
                          <span>Georg-Knorr Straße 4</span><br />
                          <span>12681 Berlin</span><br />
                          <span>Niemcy</span><br />
                          <br />
                          <span>telefon: +49 89 3547-0</span><br />
                          <span>faks: +49 89 3547-2767</span><br />
                          <span
                            >e-mail:
                            <a
                              class="font-grey"
                              href="mailto:info@knorr-bremse.com"
                              >info@knorr-bremse.com</a
                            ></span
                          ><br />
                          <br />
                          <span
                            >Zarząd: Mario Beinert, dr.Peter Radina, Harald
                            Schneider, Cora Hentrich-Henne</span
                          ><br />
                          <br />
                          <span
                            >Przewodniczący Rady Nadzorczej: Dr.Nicolas
                            Lange</span
                          ><br />
                          <span>Sąd Rejonowy w Monachium</span><br />
                          <span>Sąd Rejestrowy w Monachium: HRB 91181</span
                          ><br />
                          <span>Siedziba firmy: Monachium </span><br />
                          <span>NIP: DE129395680</span><br />

                          <a
                            href="https://training-railservices.knorr-bremse.com/files/images/KB_DS-Hinweise_Customer_Training_Portal_de.pdf"
                            >Polityka prywatności</a
                          >
                        </p>
                        <p style="padding-top: 30px">
                          Don't want to stay up to date with Knorr-Bremse
                          RailServices Training Academy?<br />
                          Zawsze możesz
                          <a href="#" style="text-decoration: none"
                            >Zrezygnuj z subskrypcji tutaj</a
                          >
                        </p>
                      </div>
                    </div>

                    <div
                      v-if="$locale === 'fr'"
                      class="popup-body"
                      style="margin-top: 30px; line-height: 1.5"
                    >
                      <div
                        class="content-1"
                        style="
                          padding-top: 30px;
                          margin-top: 30px;
                          border-top: 1px solid #d9d9d9;
                        "
                      >
                        <p style="margin: 0px; line-height: 1.5">
                          <b style="color: #000000">Mentions légales</b><br />

                          <span
                            >Knorr-Bremse Systeme für Schienenfahrzeuge
                            GmbH</span
                          ><br />
                          <span>Georg-Knorr Straße 4</span><br />
                          <span>12681 Berlin</span><br />
                          <span>Allemagne</span><br />
                          <br />
                          <span>Téléphone: +49 89 3547-0</span><br />
                          <span>Fax: +49 89 3547-2767</span><br />
                          <span
                            >Email:
                            <a
                              class="font-grey"
                              href="mailto:info@knorr-bremse.com"
                              >info@knorr-bremse.com</a
                            ></span
                          ><br />
                          <br />
                          <span
                            >PDG : Mario Beinert, Dr.Peter Radina, Harald
                            Schneider, Cora Hentrich-Henne</span
                          ><br />
                          <br />
                          <span
                            >Président du Comité de Surveillance : Nicolas
                            Lange</span
                          ><br />
                          <span>Tribunal administratif de Munich</span><br />
                          <span
                            >Numéro d’immatriculation au registre du commerce de
                            Munich : HRB 91181</span
                          ><br />
                          <span>Siège social de la société : Munich </span
                          ><br />
                          <span>N° de TVA : DE129395680</span><br />

                          <a
                            href="https://training-railservices.knorr-bremse.com/files/images/KB_DS-Hinweise_Customer_Training_Portal_en.pdf"
                            >Politique de protection des données</a
                          >
                        </p>
                        <p style="padding-top: 30px">
                          Vous ne souhaitez pas rester à jour avec Knorr-Bremse
                          RailServices Training Academy ?<br />
                          Vous pouvez toujours
                          <a href="#" style="text-decoration: none"
                            >Se désabonner ici</a
                          >
                        </p>
                      </div>
                    </div>

                    <div
                      v-if="$locale === 'hu'"
                      class="popup-body"
                      style="margin-top: 30px; line-height: 1.5"
                    >
                      <div
                        class="content-1"
                        style="
                          padding-top: 30px;
                          margin-top: 30px;
                          border-top: 1px solid #d9d9d9;
                        "
                      >
                        <p style="margin: 0px; line-height: 1.5">
                          <b style="color: #000000">Impresszum</b><br />

                          <span
                            >Knorr-Bremse Systeme für Schienenfahrzeuge
                            GmbH</span
                          ><br />
                          <span>Georg-Knorr Straße 4</span><br />
                          <span>12681 Berlin</span><br />
                          <span>Németország</span><br />
                          <br />
                          <span>Telefon: +49 89 3547-0</span><br />
                          <span>Fax: +49 89 3547-2767</span><br />
                          <span
                            >Email:
                            <a
                              class="font-grey"
                              href="mailto:info@knorr-bremse.com"
                              >info@knorr-bremse.com</a
                            ></span
                          ><br />
                          <br />
                          <span
                            >Elnökök: Mario Beinert, Dr.Peter Radina, Harald
                            Schneider, Cora Hentrich-Henne</span
                          ><br />
                          <br />
                          <span
                            >Felügyelőbizottság elnöke: Dr.Nicolas Lange</span
                          ><br />
                          <span>Müncheni Járásbíróság</span><br />
                          <span>Müncheni Cégbíróság: HRB 91181</span><br />
                          <span>A társaság székhelye: München </span><br />
                          <span>Adószám: DE129395680</span><br />

                          <a
                            href="https://training-railservices.knorr-bremse.com/files/images/KB_DS-Hinweise_Customer_Training_Portal_en.pdf"
                            >Adatvédelmi nyilatkozat</a
                          >
                        </p>
                        <p style="padding-top: 30px">
                          Nem szeretne naprakész maradni a Knorr-Bremse
                          RailServices Training Academy-vel kapcsolatban?<br />
                          Bármikor
                          <a href="#" style="text-decoration: none"
                            >Leiratkozás itt</a
                          >
                        </p>
                      </div>
                    </div>

                    <div
                      v-if="$locale === 'ru'"
                      class="popup-body"
                      style="margin-top: 30px; line-height: 1.5"
                    >
                      <div
                        class="content-1"
                        style="
                          padding-top: 30px;
                          margin-top: 30px;
                          border-top: 1px solid #d9d9d9;
                        "
                      >
                        <p style="margin: 0px; line-height: 1.5">
                          <b style="color: #000000">Выходные данные</b><br />

                          <span
                            >Knorr-Bremse Systeme für Schienenfahrzeuge
                            GmbH</span
                          ><br />
                          <span>Georg-Knorr Straße 4</span><br />
                          <span>12681 Berlin</span><br />
                          <span>Deutschland (Германия)</span><br />
                          <br />
                          <span>Телефон: +49 89 3547-0</span><br />
                          <span>Факс: +49 89 3547-2767</span><br />
                          <span
                            >Электронная почта:
                            <a
                              class="font-grey"
                              href="mailto:info@knorr-bremse.com"
                              >info@knorr-bremse.com</a
                            ></span
                          ><br />
                          <br />
                          <span
                            >Руководство:Марио Байнерт (Mario Beinert), д-р
                            Петер Родина (Dr. Peter Radina), Харальд Шнайдер
                            (Harald Schneider), Кора Хентрих-Хенне (Cora
                            Hentrich-Henne)</span
                          ><br />
                          <br />
                          <span
                            >Председатель Наблюдательного совета:д-р Николас
                            Ланге (Dr. Nicolas Lange)</span
                          ><br />
                          <span>Участковый суд Мюнхена</span><br />
                          <span>Отдел торгового реестра Мюнхена: HRB 91181</span
                          ><br />
                          <span>RМестонахождение компании: г. Мюнхен </span
                          ><br />
                          <span
                            >Идентификационный номер плательщика НДС:
                            DE129395680</span
                          ><br />

                          <a
                            href="https://training-railservices.knorr-bremse.com/files/images/KB_DS-Hinweise_Customer_Training_Portal_en.pdf"
                            >Политика конфиденциальности</a
                          >
                        </p>
                        <p style="padding-top: 30px">
                          Не хотите быть в курсе последних событий, связанных с
                          Учебной академией Knorr-Bremse RailServices?<br />
                          Вы всегда можете
                          <a href="#" style="text-decoration: none"
                            >Отписаться здесь</a
                          >
                        </p>
                      </div>
                    </div>

                    <div
                      v-if="$locale === 'kk'"
                      class="popup-body"
                      style="margin-top: 30px; line-height: 1.5"
                    >
                      <div
                        class="content-1"
                        style="
                          padding-top: 30px;
                          margin-top: 30px;
                          border-top: 1px solid #d9d9d9;
                        "
                      >
                        <p style="margin: 0px; line-height: 1.5">
                          <b style="color: #000000"
                            >Компания бойынша мәліметтер</b
                          ><br />

                          <span
                            >Knorr-Bremse Systeme für Schienenfahrzeuge
                            GmbH</span
                          ><br />
                          <span>Georg-Knorr Straße 4</span><br />
                          <span>12681 Берлин</span><br />
                          <span>Германия</span><br />
                          <br />
                          <span>Телефон: +49 89 3547-0</span><br />
                          <span>Факс: +49 89 3547-2767</span><br />
                          <span
                            >Электрондық пошта:
                            <a
                              class="font-grey"
                              href="mailto:info@knorr-bremse.com"
                              >info@knorr-bremse.com</a
                            ></span
                          ><br />
                          <br />
                          <span
                            >Бас атқарушы директор: Mario Beinert, Dr.Peter
                            Radina, Harald Schneider, Cora Hentrich-Henne</span
                          ><br />
                          <br />
                          <span
                            >Бақылау кеңесінің төрағасы: Dr.Nicolas Lange</span
                          ><br />
                          <span>Мюнхен қаласының жергілікті соты</span><br />
                          <span>Мюнхен қаласының тіркеу соты: HRB 91181</span
                          ><br />
                          <span>Компанияның тіркелген мекені: Мюнхен </span
                          ><br />
                          <span>ҚҚС төлеушінің жеке нөмірі: DE129395680</span
                          ><br />

                          <a
                            href="https://training-railservices.knorr-bremse.com/files/images/KB_DS-Hinweise_Customer_Training_Portal_en.pdf"
                            >Дербес деректерді қорғау бойынша мәлімдеме</a
                          >
                        </p>
                        <p style="padding-top: 30px">
                          Knorr-Bremse RailServices Training Academy туралы
                          хабардар болғыңыз келмей ме?<br />
                          Сіз әрқашан аласыз
                          <a href="#" style="text-decoration: none"
                            >Мұнда жазылудан бас тартыңыз</a
                          >
                        </p>
                      </div>
                    </div>

                    <div
                      v-if="$locale === 'es'"
                      class="popup-body"
                      style="margin-top: 30px; line-height: 1.5"
                    >
                      <div
                        class="content-1"
                        style="
                          padding-top: 30px;
                          margin-top: 30px;
                          border-top: 1px solid #d9d9d9;
                        "
                      >
                        <p style="margin: 0px; line-height: 1.5">
                          <b style="color: #000000">Aviso legal</b><br />

                          <span
                            >Knorr-Bremse Systeme für Schienenfahrzeuge
                            GmbH</span
                          ><br />
                          <span>Georg-Knorr Straße 4</span><br />
                          <span>12681 Berlin</span><br />
                          <span>Alemania</span><br />
                          <br />
                          <span>Telephone: +49 89 3547-0</span><br />
                          <span>Fax: +49 89 3547-2767</span><br />
                          <span
                            >Correo electrónico:
                            <a
                              class="font-grey"
                              href="mailto:info@knorr-bremse.com"
                              >info@knorr-bremse.com</a
                            ></span
                          ><br />
                          <br />
                          <span
                            >Director ejecutivo: Mario Beinert, Dr.Peter Radina,
                            Harald Schneider, Cora Hentrich-Henne</span
                          ><br />
                          <br />
                          <span
                            >Presidente del Consejo de Supervisión: Dr.Nicolas
                            Lange</span
                          ><br />
                          <span>Tribunal Local de Múnich</span><br />
                          <span>Tribunal de Registro de Múnich: HRB 91181</span
                          ><br />
                          <span>Domicilio social de la empresa: Múnich </span
                          ><br />
                          <span
                            >Número de identificación fiscal: DE129395680</span
                          ><br />

                          <a
                            href="https://training-railservices.knorr-bremse.com/files/images/KB_DS-Hinweise_Customer_Training_Portal_en.pdf"
                            >Política de privacidad</a
                          >
                        </p>
                        <p style="padding-top: 30px">
                          ¿No quieres mantenerte al día con la Academia de
                          formación RailServices de Knorr-Bremse?<br />
                          Siempre puedes
                          <a href="#" style="text-decoration: none"
                            >Darse de baja aquí</a
                          >
                        </p>
                      </div>
                    </div>

                    <div
                      v-if="$locale === 'it'"
                      class="popup-body"
                      style="margin-top: 30px; line-height: 1.5"
                    >
                      <div
                        class="content-1"
                        style="
                          padding-top: 30px;
                          margin-top: 30px;
                          border-top: 1px solid #d9d9d9;
                        "
                      >
                        <p style="margin: 0px; line-height: 1.5">
                          <b style="color: #000000">Imprint</b><br />

                          <span
                            >Knorr-Bremse Systeme für Schienenfahrzeuge
                            GmbH</span
                          ><br />
                          <span>Georg-Knorr Straße 4</span><br />
                          <span>12681 Berlin</span><br />
                          <span>Germany</span><br />
                          <br />
                          <span>Telephone: +49 89 3547-0</span><br />
                          <span>Fax: +49 89 3547-2767</span><br />
                          <span
                            >Email:
                            <a
                              class="font-grey"
                              href="mailto:info@knorr-bremse.com"
                              >info@knorr-bremse.com</a
                            ></span
                          ><br />
                          <br />
                          <span
                            >Amministratore delegato: Mario Beinert, Dr.Peter
                            Radina, Harald Schneider, Cora Hentrich-Henne</span
                          ><br />
                          <br />
                          <span
                            >Presidente del consiglio di vigilanza: Dr.Nicolas
                            Lange</span
                          ><br />
                          <span>Pretura di Monaco</span><br />
                          <span
                            >Registro delle imprese del tribunale di Monaco: HRB
                            91181</span
                          ><br />
                          <span
                            >Sede legale della società: Monaco di Baviera</span
                          ><br />
                          <span>P.IVA: DE129395680</span><br />

                          <a
                            href="https://training-railservices.knorr-bremse.com/files/images/KB_DS-Hinweise_Customer_Training_Portal_en.pdf"
                            >Informativa sulla privacy</a
                          >
                        </p>
                        <p style="padding-top: 30px">
                          Non volete essere aggiornati sulla Knorr-Bremse
                          RailServices Training Academy?<br />
                          Si può sempre
                          <a href="#" style="text-decoration: none"
                            >Annullamento dell'iscrizione qui</a
                          >
                        </p>
                      </div>
                    </div>

                    <div
                      v-if="$locale === 'zh'"
                      class="popup-body"
                      style="margin-top: 30px; line-height: 1.5"
                    >
                      <div
                        class="content-1"
                        style="
                          padding-top: 30px;
                          margin-top: 30px;
                          border-top: 1px solid #d9d9d9;
                        "
                      >
                        <p style="margin: 0px; line-height: 1.5">
                          <b style="color: #000000">版权</b><br />

                          <span
                            >Knorr-Bremse Systeme für Schienenfahrzeuge
                            GmbH</span
                          ><br />
                          <span>Georg-Knorr Straße 4</span><br />
                          <span>12681 Berlin</span><br />
                          <span>Germany</span><br />
                          <br />
                          <span>电话: +49 89 3547-0</span><br />
                          <span>传真: +49 89 3547-2767</span><br />
                          <span
                            >邮箱:
                            <a
                              class="font-grey"
                              href="mailto:info@knorr-bremse.com"
                              >info@knorr-bremse.com</a
                            ></span
                          ><br />
                          <br />
                          <span
                            >首席执行官: Mario Beinert, Peter Radina 博士,
                            Harald Schneider, Cora Hentrich-Henne</span
                          ><br />
                          <br />
                          <span>监事会主席：Nicolas Lange 博士</span><br />
                          <span>慕尼黑地方法院</span><br />
                          <span>慕尼黑注册法院: HRB 91181</span><br />
                          <span>公司注册地：慕尼黑</span><br />
                          <span>增值税号: DE129395680</span><br />

                          <a
                            href="https://training-railservices.knorr-bremse.com/files/images/KB_DS-Hinweise_Customer_Training_Portal_zh.pdf"
                            >隐私政策</a
                          >
                        </p>
                        <p style="padding-top: 30px">
                          不想了解克诺尔制动系统有限公司培训学院的最新信息？<br />
                          您可以随时
                          <a href="#" style="text-decoration: none">在此退订</a>
                        </p>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-simple-table>
            <div class="span_wrap">
              <span class="sppn"
                >{{ totalRecordsNewsLetter > 0 ? pageNewsLetter : 0 }} &nbsp;{{
                  this.$t("of")
                }}&nbsp;{{ totalPagesNewsLetter }} ({{
                  totalRecordsNewsLetter
                }}
                {{ this.$t("records") }})
              </span>
              <span class="no_ra" v-if="totalRecordsNewsLetter == 0">{{
                $t("no_records")
              }}</span>
            </div>
            <pagination
              class="my-2"
              :current-page="pageNewsLetter"
              :total-pages="totalPagesNewsLetter"
              :show-previous-page="previousPageNewsLetter"
              :show-next-page="nextPageNewsLetter"
              :show-current-page="showCurrentPageNewsLetter"
            ></pagination>
          </v-tab-item>
        </v-tabs-items>

        <div class="text-center">
          <v-dialog v-model="openDeleteDialog" content-class="dng_popup">
            <h4>{{ $t("are_you_sure") }}</h4>
            <p class="align_center">{{ $t("delete_record") }}</p>
            <p class="align_center mb-4">{{ $t("cannot_be_undone") }}</p>
            <v-card-actions class="align_center g-space-15">
              <v-btn
                @click="openDeleteDialog = false"
                outlined
                depressed
                tile
                class="cancelBtn"
              >
                {{ $t("cancel") }}</v-btn
              >
              <v-btn
                @click="deleteNewsLetter()"
                outlined
                depressed
                tile
                class="savebutton"
              >
                <v-icon color="#444">mdi-delete</v-icon>
                {{ $t("delete") }}</v-btn
              >
            </v-card-actions>
          </v-dialog>

          <v-dialog
            v-model="assignDialog"
            content-class="dng_popup dng_popup_center"
          >
            <img
              src="/static/img/sub_bluetick.svg"
              class="bluetick"
              alt="edit"
            />
            <p class="align_center mb-6">
              {{ $t("selected_subscriber_moved_to") }}<br />
              <b>'{{ assinedGroupName }}'</b>
              {{ $t("group_successfully") }}
            </p>
            <v-card-actions class="align_center g-space-15">
              <v-btn @click="assignDialogClose" class="close_btn_link">
                {{ $t("close") }}</v-btn
              >
            </v-card-actions>
          </v-dialog>
          <v-dialog
            v-model="removeDialog"
            content-class="dng_popup dng_popup_center"
          >
            <img
              src="/static/img/sub_bluetick.svg"
              alt="edit"
              class="bluetick"
            />
            <p class="align_center mb-6">
              {{ $t("selected_groups_removed_successfully") }}
            </p>
            <v-card-actions class="align_center g-space-15">
              <v-btn @click="assignDialogClose" class="close_btn_link">
                {{ $t("close") }}</v-btn
              >
            </v-card-actions>
          </v-dialog>
          <v-dialog v-model="createDialog" content-class="cng_popup">
            <div class="d-flex name_input_manage">
              <p v-if="editMode">{{ $t("edit_audience") }}</p>
              <p v-else>{{ $t("create_a_new_group") }}</p>
              <p>{{ $t("subscriber_group_name") }}</p>
              <v-text-field
                hide-details="auto"
                class="datainput justify-content-end align-self-center pb-1 sto_newsletter_select_first"
                dense
                outlined
                :label="$t('enter_subscriber_group')"
                v-model="request.designation"
                :error-messages="validationErrors.designation"
                @input="clearNameError"
              ></v-text-field>
            </div>

            <v-card-actions class="g-space-15">
              <v-btn
                @click="createNewsLetterAudience"
                outlined
                depressed
                tile
                class="savebutton"
              >
                {{ $t("save") }}
              </v-btn>
              <v-btn
                @click="createDialog = false"
                outlined
                depressed
                tile
                class="cancelBtn"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-card-actions>
          </v-dialog>
          <v-dialog v-model="audienceDeleteDialog" content-class="dng_popup">
            <h4>{{ $t("are_you_sure") }}</h4>
            <p class="align_center">{{ $t("delete_record") }}</p>
            <p class="align_center mb-6">{{ $t("cannot_be_undone") }}</p>
            <v-card-actions class="align_center g-space-15">
              <v-btn
                @click="audienceDeleteDialog = false"
                outlined
                depressed
                tile
                class="cancelBtn"
              >
                {{ $t("cancel") }}</v-btn
              >
              <v-btn
                @click="deleteAudience()"
                outlined
                depressed
                tile
                class="savebutton"
              >
                <v-icon color="#444">mdi-delete</v-icon>
                {{ $t("delete") }}</v-btn
              >
            </v-card-actions>
          </v-dialog>
          <v-dialog v-model="subscriberDeleteDialog" content-class="dng_popup">
            <h4>{{ $t("are_you_sure") }}</h4>
            <p class="align_center">{{ $t("delete_record") }}</p>
            <p class="align_center mb-6">{{ $t("cannot_be_undone") }}</p>
            <v-card-actions class="align_center g-space-15">
              <v-btn
                @click="subscriberDeleteDialog = false"
                outlined
                depressed
                tile
                class="cancelBtn"
              >
                {{ $t("cancel") }}</v-btn
              >
              <v-btn
                @click="deleteSubscriber()"
                outlined
                depressed
                tile
                class="savebutton"
              >
                <v-icon color="#444">mdi-delete</v-icon>
                {{ $t("delete") }}</v-btn
              >
            </v-card-actions>
          </v-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pagination from "./custom/pagination.vue";
import Breadcrumb from "./Breadcrumbs.vue";

export default {
  components: {
    pagination,
    Breadcrumb,
  },

  data() {
    return {
      removeDialog: false,
      subscriberDeleteDialog: false,
      menu: false,
      selectedAudience: 0,
      showAudienace: false,
      selectedTab: 0,
      totalRecords: 0,
      currentPageRecordCount: 0,
      nextPrevious: false,
      page: 1,
      totalPages: 1,
      totalRecordsNewsLetter: 0,
      currentPageRecordCountNewsLetter: 0,
      nextPreviousNewsLetter: false,
      pageNewsLetter: 1,
      totalPagesNewsLetter: 1,
      ElementPerPage: 50,
      sort: null,
      order: true,
      subscribers: [],
      newsletters: [],
      openDeleteDialog: false,
      newsLetter: null,
      openPreviewDialog: false,
      newsLetterDuplicate: null,
      newsLetterToDelete: null,
      subscriberLanguage: null,
      currentPageNewsLetter: null,
      currentPage: null,
      numberOfElementsNewsLetter: null,
      numberOfElements: null,
      showSubscriber: true,
      audiences: [],
      request: {
        designation: "",
      },
      validationErrors: {
        designation: "",
      },
      createDialog: false,
      editMode: false,
      selectedSubscriber: [],
      selectedGroups: [],
      assinedGroupName: "",
      assignDialog: false,
      audienceDeleteDialog: false,
      audienceDelete: null,
      subscribersAlllength: 0,
    };
  },

  mounted() {
    if (
      this.isLoad != true &&
      !window.location.href.includes("?") &&
      !window.location.href.includes("?lang=")
    ) {
      this.isLoad = true;
      window.location.href =
        window.location.href + "?lang=" + this.$locale.toUpperCase();
    }
    const selectedTab = parseInt(this.$route.query.selectedTab) || 0;
    this.selectedTab = selectedTab;
    progressIndicator.hidden = false;
    showLoadingCircle(true);
    this.getNewsLetter();
    this.getAllSubcriber();
    this.fetchAllAudience();
    this.getAllSubcriberGet();
  },

  methods: {
    goToCreateNewsletter() {
      this.$router.push("/create-news-letter");
    },
    openDeleteAudienceDialog(id) {
      this.audienceDeleteDialog = true;
      this.audienceDelete = id;
    },
    openDeleteSubscriberDialog(id) {
      this.subscriberDeleteDialog = true;
      this.subscriberDelete = id;
    },
    assignDialogClose() {
      this.assignDialog = false;
      this.removeDialog = false;
      this.getAllSubcriber();
    },
    getSubscribersWithAudienceFilter(id) {
      this.selectedAudience = id;
      this.showAudienace = false;
      this.showSubscriber = true;
      this.getAllSubcriberForSelectedAudience();
    },
    getAudienceGroup(audiences) {
      return audiences.map((a) => a.designation).join(", ");
    },
    getAudienceGroupName(audienceIds) {
      this.assinedGroupName = audienceIds
        .map((id) => this.audiences.find((a) => a.id === id))
        .filter((a) => a) // filter out undefined in case ID not found
        .map((a) => a.designation)
        .join(", ");
    },
    getAudienceGroupNameSubscriber(audienceIds) {
      return audienceIds
        .map((id) => this.audiences.find((a) => a.id === id))
        .filter((a) => a) // filter out undefined in case ID not found
        .map((a) => a.designation)
        .join(", ");
    },
    assignGroups() {
      if (this.selectedGroups.length == 0) {
        this.$noty.error(this.$t("please_select_subscriber_group"));
        return;
      }
      if (this.selectedSubscriber.length == 0) {
        this.$noty.error(this.$t("please_select_subscriber"));
        return;
      }

      this.menu = false;
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      var _this = this;
      this.$axios
        .post("api/newsletter/newsletter-audience-assign", {
          selectedGroups: this.selectedGroups,
          selectedSubscriber: this.selectedSubscriber,
        })
        .then((response) => {
          _this.getAudienceGroupName(_this.selectedGroups);
          _this.selectedGroups = [];
          _this.selectedSubscriber = [];
          _this.assignDialog = true;
          //    _this.selectedAudience = 0;
          _this.fetchAllAudience();
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },

    removeGroups() {
      if (this.selectedSubscriber.length == 0) {
        this.$noty.error(this.$t("please_select_subscriber"));
        return;
      }

      this.menu = false;
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      var _this = this;
      this.$axios
        .post("api/newsletter/newsletter-audience-assign", {
          selectedSubscriber: this.selectedSubscriber,
        })
        .then((response) => {
          _this.selectedSubscriber = [];
          _this.selectedGroups = [];
          _this.removeDialog = true;
          _this.fetchAllAudience();
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },
    showAudienaceTab() {
      this.showAudienace = true;
      this.showSubscriber = false;
    },
    showSubscriberTab() {
      this.getAllSubcriber();
      this.showAudienace = false;
      this.showSubscriber = true;
    },
    openDialog(request = null) {
      if (request) {
        this.request = request;
        this.editMode = true;
      } else {
        this.request.designation = "";
        this.request.id = null;
        this.editMode = false;
      }
      this.createDialog = true;
    },
    clearNameError() {
      if (this.request.designation.trim()) {
        this.validationErrors.designation = "";
      }
    },
    fetchAllAudience() {
      var _this = this;
      this.$axios
        .get("/api/newsletter/get-newsletter-audience")
        .then(function (response) {
          _this.audiences = response.data;
        })
        .catch(this.onError);
    },
    createNewsLetterAudience() {
      var _this = this;
      if (!this.request.designation.trim()) {
        _this.$noty.error(this.$t("enter_group_name"));
        return;
      }
      if (!this.editMode) {
        this.$axios
          .post("api/newsletter/newsletter-audience-create", this.request)
          .then(function (response) {
            _this.request.designation = null;
            _this.$noty.success(_this.$t("created_audience_sucessfully"));
            _this.createDialog = false;
            _this.fetchAllAudience();
          })
          .catch(this.onError);
      } else {
        this.$axios
          .put(
            "api/newsletter/newsletter-audience-update/" + this.request.id,
            this.request
          )
          .then(function (response) {
            _this.request.designation = null;
            _this.request.id = null;
            _this.$noty.success(_this.$t("updated_audience_sucessfully"));
            _this.createDialog = false;
            _this.fetchAllAudience();
          })
          .catch(this.onError);
      }
    },
    onError(err) {
      if (err.response != null && err.response.data != null) {
        this.$noty.error(err.response.data);
      } else {
        console.error(err);
      }
    },
    clearData() {
      this.request.designation = null;
      this.createDialog = false;
    },
    onFinally() {
      showLoadingCircle(false);
    },
    onError(err) {
      if (err.response != null && err.response.data != null) {
        this.$noty.error(err.response.data);
      } else {
        console.error(err);
      }
    },
    createDuplicate(newsLetterId) {
      let _this = this;
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      this.$axios
        .get("/api/newsletter/newsletter/" + parseInt(newsLetterId))
        .then(function (response) {
          _this.newsLetterDuplicate = response.data;
          _this.newsLetterDuplicate.newsletterStatus = "0";
          _this.newsLetterDuplicate.isDuplicated = "1";
          delete _this.newsLetterDuplicate.id;
          _this.newsLetterDuplicate.body = {
            ..._this.newsLetterDuplicate.bodyMap,
          };
          _this.newsLetterDuplicate.subjectLine = {
            ..._this.newsLetterDuplicate.subjectMap,
          };

          delete _this.newsLetterDuplicate.bodyMap;
          delete _this.newsLetterDuplicate.subjectMap;
          _this.$axios
            .post("/api/newsletter/newsletter/", _this.newsLetterDuplicate)
            .then(function (response) {
              _this.getNewsLetter();
            });
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },
    formatDate(dateString) {
      if (!dateString) return "";

      const date = new Date(dateString);
      return date.toLocaleString("en-US", {
        weekday: "short", // Mon
        month: "short", // Jan
        day: "numeric", // 2
        year: "numeric", // 2024
        hour: "numeric", // 12
        minute: "2-digit", // 05
        hour12: true, // 12-hour format with am/pm
      });
    },
    tableRowClicked(newsLetterId) {
      this.$router.push("/edit-news-letter?newsLetterId=" + newsLetterId);
    },
    tableRowClickedDelete(newsLetterId) {
      this.openDeleteDialog = true;
      this.newsLetterToDelete = newsLetterId;
    },
    deleteNewsLetter() {
      let _this = this;
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      _this.$axios
        .delete("/api/newsletter/newsletter/" + _this.newsLetterToDelete)
        .then(function (response) {
          _this.openDeleteDialog = false;
          _this.getNewsLetter();
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },
    showPreviewPopUp(newsLetterId) {
      let _this = this;
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      this.$axios
        .get("/api/newsletter/newsletter/" + newsLetterId)
        .then(function (response) {
          _this.openPreviewDialog = true;
          _this.newsLetter = response.data;
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },
    previousPage() {
      this.page = this.page - 1;
      this.getAllSubcriber();
    },
    nextPage() {
      this.page = this.page + 1;
      this.getAllSubcriber();
    },
    showCurrentPage(pageNumber) {
      this.page = pageNumber;
      this.getAllSubcriber();
    },
    previousPageNewsLetter() {
      this.pageNewsLetter = this.pageNewsLetter - 1;
      this.getNewsLetter();
    },
    nextPageNewsLetter() {
      this.pageNewsLetter = this.pageNewsLetter + 1;
      this.getNewsLetter();
    },
    showCurrentPageNewsLetter(pageNumber) {
      this.pageNewsLetter = pageNumber;
      this.getNewsLetter();
    },
    getAllSubcriber() {
      var _this = this;
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      this.$axios
        .get("api/newsletter", {
          params: {
            page: _this.page - 1,
          },
        })
        .then(function (response) {
          _this.subscribers = response.data.content;
          _this.totalRecords = response.data.totalElements;
          _this.totalPages = response.data.totalPages;
          _this.currentPage = response.data.number;
          _this.numberOfElements = response.data.size;
          _this.$forceUpdate();
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },

    getAllSubcriberGet() {
      var _this = this;
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      this.$axios
        .get("api/newsletter", {
          params: {
            page: _this.page - 1,
          },
        })
        .then(function (response) {
          _this.subscribersAlllength = response.data.totalElements;
          _this.$forceUpdate();
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },
    deleteAudience() {
      let _this = this;
      _this.audienceDeleteDialog = false;
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      _this.$axios
        .delete("/api/newsletter/delete-audience/" + _this.audienceDelete)
        .then(function (response) {
          _this.$noty.success(_this.$t("deleted_audience_sucessfully"));
          _this.selectedAudience = 0;
          _this.fetchAllAudience();
          _this.getAllSubcriber();
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },
    deleteSubscriber() {
      let _this = this;
      _this.subscriberDeleteDialog = false;
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      _this.$axios
        .delete(
          "/api/newsletter/newsletter-subscription-delete/" +
            _this.subscriberDelete
        )
        .then(function (response) {
          _this.$noty.success(_this.$t("deleted_subscriber_sucessfully"));
          _this.selectedAudience = 0;
          _this.fetchAllAudience();
          _this.getAllSubcriber();
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },
    getAllSubcriberForSelectedAudience() {
      var _this = this;
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      this.$axios
        .get("api/newsletter", {
          params: {
            page: _this.page - 1,
            selectedAudience: _this.selectedAudience,
          },
        })
        .then(function (response) {
          _this.subscribers = response.data.content;
          _this.totalRecords = response.data.totalElements;
          _this.totalPages = response.data.totalPages;
          _this.currentPage = response.data.number;
          _this.numberOfElements = response.data.size;
          _this.$forceUpdate();
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },
    getNewsLetter() {
      var _this = this;
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      this.$axios
        .get("api/newsletter/newsletter", {
          params: {
            page: _this.pageNewsLetter - 1,
          },
        })
        .then(function (response) {
          _this.newsletters = response.data.content;
          _this.totalRecordsNewsLetter = response.data.totalElements;
          _this.totalPagesNewsLetter = response.data.totalPages;
          _this.currentPageNewsLetter = response.data.number;
          _this.numberOfElementsNewsLetter = response.data.size;
          _this.$forceUpdate();
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },
    getAllSelectedAudienceIds() {
      const audienceIdSet = new Set();
      for (let subscriber of this.subscribers) {
        if (this.selectedSubscriber.includes(subscriber.id)) {
          if (Array.isArray(subscriber.audiences)) {
            for (let audience of subscriber.audiences) {
              audienceIdSet.add(audience.id);
            }
          }
        }
      }
      this.selectedGroups = Array.from(audienceIdSet);
    },
  },
  computed: {
    possiblelanguagesComputed() {
      return this.$root.languageTabsNew.map((language) => ({
        name: language.translatedName,
        flag: language.flag,
        shortForm: language.shortForm,
        value: language.language,
      }));
    },

    getFlag() {
      return (languageCode) => {
        const language = this.possiblelanguagesComputed.find(
          (l) => l.value === languageCode
        );
        return language ? language.flag : "";
      };
    },

    getLanguageName() {
      return (languageCode) => {
        const language = this.possiblelanguagesComputed.find(
          (l) => l.value === languageCode
        );
        return language ? language.name : "";
      };
    },
    itemsAudience() {
      return [
        {
          name: this.$t("all") + " (" + this.subscribersAlllength + ")",
          id: 0,
        },
        ...this.audiences.map((item) => ({
          name: item.designation + " (" + item.subscriptionCount + ")",
          id: item.id,
        })),
      ];
    },
  },
};
</script>
